module.exports = __webpack_public_path__ + "img/中鼎.png";